
import { useNavigate } from 'react-router';
import { Button } from '@/components/ui';

export function UnauthorizedContent() {
  const navigate = useNavigate();

  return (
    <div className="text-center max-w-md">
      {/* Icon */}
      <div className="mx-auto w-16 h-16 mb-6 rounded-full bg-red-100 dark:bg-red-900/30 flex items-center justify-center">
        <svg
          className="w-8 h-8 text-red-600 dark:text-red-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
          />
        </svg>
      </div>

      <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-4">
        Access Denied
      </h1>
      <p className="text-slate-600 dark:text-slate-400 mb-8">
        You don&apos;t have permission to access this page. Please contact an administrator if you believe this is an error.
      </p>

      <div className="flex flex-col sm:flex-row gap-3 justify-center">
        <Button variant="primary" onClick={() => navigate('/')}>
          Return to Home
        </Button>
        <Button variant="outline" onClick={() => navigate('/login')}>
          Sign in with different account
        </Button>
      </div>
    </div>
  );
}
